import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={22}
    fill="none"
    {...props}
  >
    <path
      fill="#111"
      d="M1.766 15.05a8.25 8.25 0 0 1-.825-1.95 7.696 7.696 0 0 1-.275-2.05c0-2.233.775-4.133 2.325-5.7C4.541 3.783 6.433 3 8.666 3h.175l-1.6-1.6 1.4-1.4 4 4-4 4-1.4-1.4 1.6-1.6h-.175c-1.667 0-3.083.588-4.25 1.763-1.167 1.175-1.75 2.604-1.75 4.287 0 .433.05.858.15 1.275.1.417.25.825.45 1.225l-1.5 1.5ZM8.691 22l-4-4 4-4 1.4 1.4-1.6 1.6h.175c1.667 0 3.083-.587 4.25-1.762 1.167-1.175 1.75-2.605 1.75-4.288 0-.433-.05-.858-.15-1.275-.1-.417-.25-.825-.45-1.225l1.5-1.5c.367.633.642 1.283.825 1.95.183.667.275 1.35.275 2.05 0 2.233-.775 4.133-2.325 5.7-1.55 1.567-3.442 2.35-5.675 2.35h-.175l1.6 1.6-1.4 1.4Z"
    />
  </svg>
)
export default SvgComponent
